<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="dense" :label="$lang.dense" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="vertical" :label="$lang.vertical" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <steps
          step-clickable
          error-color="yellow"
          :dense="dense"
          :vertical="vertical"
          :error-color-lightness="500"
          :color="$root.colors.primary"
          :color-lightness="$root.colors.bgColorLightness"
          :items="steps"
          :error="error"
          :current-step="currentStep"
          @step-click="onStepClick" />
      </flex-col>
      <flex-col :span="24">
        <card>
          <card-actions align="center">
            <btn :title="$lang.previous" :class="['mr-1']" color="white" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" size="sm" @click="step(false)" :disabled="[-1, 0].includes(currentStep)" icon-left="chevron-left" /><!--
        --><btn :title="$lang.next" :class="['mr-1']" color="white" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" size="sm" @click="step()" :disabled="currentStep === steps.length - 1" icon-left="chevron-right" /><!--
        --><btn :disabled="currentStep === -1" :class="['mr-1']" color="white" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" size="sm" :title="$lang.reset" @click="reset" icon-left="refresh" /><!--
        --><btn-group mandatory :disabled="currentStep === -1" v-model="status" type="exclusive" :buttons="buttons" size="sm" rounded color="white" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" />
          </card-actions>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageSteps',
  mixins: [
    methods
  ],
  data () {
    return {
      steps: [],
      currentStep: -1,
      status: ['process'],
      dense: true,
      vertical: false,
      buttons: ['Error', 'Process'].map(label => {
        return {
          label,
          hint: label,
          value: label.toLowerCase()
        }
      })
    }
  },
  computed: {
    error () {
      return this.status[0] === 'error' ? this.currentStep : null
    }
  },
  mounted () {
    this.getExternalData('steps.json', 'steps')
  },
  methods: {
    onStepClick ($event) {
      this.log('step-click', 'steps', $event)
    },
    step (next = true) {
      this.currentStep = next ? this.currentStep + 1 : this.currentStep - 1
    },
    reset () {
      this.currentStep = -1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/steps.vue